import { API_URL } from "../../shared/utils/Util";
import { getFetchT } from "../../shared/utils/TypedUtil";
import { GetCampaignPaidOrdersResponse } from "../../types/api";

export function getCampaignPaidOrders(
  restaurantId: string,
  campaignId: string,
  handleResponse: (result: GetCampaignPaidOrdersResponse) => void,
  handleError: (err: any) => void
) {
  getFetchT<GetCampaignPaidOrdersResponse>(
    `${API_URL}/v1/r/${restaurantId}/campaigns/${campaignId}/paid_orders`,
    handleResponse,
    handleError
  );
}
